import React from 'react';
import { FilterVehicle } from './vehicle/FilterVehicle';
import { FilterAmenity } from '../../filter-bases';
import FilterInOut from './in-out/FilterInOut';
import TotalToggle from './total-toggle';
import { useSelector } from 'react-redux';
import { SearchPageView } from 'utils/search-page-view';
import FilterLoyaltyProgram from './loyalty-program';
import { FilterSpotSort } from './spot-sort/FilterSpotSort';
export const FiltersHourly = () => {
    const view = useSelector((s) => s.search.data.view);
    return (<>
            <FilterSpotSort />
            <FilterLoyaltyProgram />
            <FilterVehicle />
            <FilterInOut />
            <FilterAmenity amenity="self-park">Self Park</FilterAmenity>
            {view === SearchPageView.DESKTOP_LIST && (<FilterAmenity amenity="covered-parking">
                    Garage - Covered
                </FilterAmenity>)}
            <TotalToggle />
        </>);
};
